import * as React from 'react';

interface ClowncarHeaderV2Props {
  heading: string;
  actions?: React.ReactNode;
  cta?: React.ReactNode;
}

/**
 * Modern header component for Clowncar pages.
 *
 * @example
 * <ClowncarHeaderV2
 *   heading="Page Title"
 *   actions={<Button>Action</Button>}
 *   cta={<Button>Call to Action</Button>}
 * />
 */
const ClowncarHeaderV2: React.FC<ClowncarHeaderV2Props> = ({ heading, actions, cta }) => {
  return (
    <div className="ClowncarHeader" data-testid="clowncar-header">
      <div className="ClowncarHeader-content">
        {heading}
        {actions && <div className="ClowncarHeader-actions">{actions}</div>}
        {cta}
      </div>
    </div>
  );
};

export default ClowncarHeaderV2;
